import React from "react";
import PropTypes from "prop-types";
import ChimneyProfileWebsitesContainer from "./Containers/ChimneyProfileWebsitesContainer";
//import { Test } from './ProfileTopTen.styles';

const ProfileWebsites = (props) => (
  <ChimneyProfileWebsitesContainer
    chimDir={props.chimDir}
    render={({ websites }) => (
      <div className="profile-right-nav profile-top-ten">
        <h3>Favorite Websites</h3>
        <ul className="list-flat">
          {websites.map((website, i) => (
            <li key={i}>
              <a href={website.link} target="_blank" rel="noopener noreferrer">
                {website.link.length > 44 ? website.link.substr(0, 44) + "..." : website.link}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )}
  />
);

ProfileWebsites.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default ProfileWebsites;
